import React from "react";
import { VariantModel } from "../models/VariantModel";
import { ModelwalkModel } from "../models/ModelwalkModel";
import ModelWalk from "../components/ModelWalk/ModelWalk";
import SpecsFeaturesTable from "../components/SpecsFeatures/SpecsFeaturesTable";
import { ModelName } from "../utils/ModelName";

interface SpecsComparisonState {
  selectedIndex: number;
  showSedan: boolean;
}

interface SpecsComparisonProps {
  content?: ModelwalkModel;
  specsAndFeaturesDisclaimer: string;
}

class SpecsComparison extends React.Component<
  SpecsComparisonProps,
  SpecsComparisonState
> {
  constructor(props: SpecsComparisonProps) {
    super(props);

    this.state = {
      selectedIndex: 0,
      showSedan: true,
    };

    this.update = this.update.bind(this);
    this.toggleVariant = this.toggleVariant.bind(this);
  }

  get filteredVariants(): VariantModel[] {
    const { showVariantGrouping, variants, modelName } = this.props.content;
    const showSedan = this.state.showSedan;
    let variantsList = [];

    if (showVariantGrouping && modelName.toLowerCase() === "wrx") {
      if (showSedan) {
        variantsList = variants.filter((v) => v.variantType == "Sedan");
      } else {
        variantsList = variants.filter((v) => v.variantType == "Sportswagon");
      }
    } else {
      variantsList = variants;
    }

    return variantsList.filter((v) => !v.hideFromModelWalk);
  }

  update(selectedIndex: number) {
    this.setState({ selectedIndex });
  }

  toggleVariant(showSedan: boolean) {
    this.setState({ showSedan });
  }

  render() {
    return (
      <div>
        <ModelWalk
          content={this.props.content}
          comparisonMode={true}
          onUpdate={this.update}
          startIndex={this.state.selectedIndex}
          includeHeader={true}
          hidePriceDisclaimer={window["hidePriceDisclaimer"]}
          priceDisclaimerOverride={window["priceDisclaimerOverride"]}
          toggleVariant={this.toggleVariant}
          hideRepayment={true}
        />

        {/* <div className="text-center spacing-bottom">
          <p>{`Not sure the ${ModelName} is right for you?`}</p>
          <p>
            <a href="https://www.subaru.com.au/help-me-choose" className="btn btn--secondary">
              Help me choose the right Subaru
            </a>
          </p>
        </div> */}

        <SpecsFeaturesTable
          content={this.filteredVariants}
          currentIndex={this.state.selectedIndex}
          specsAndFeaturesDisclaimer={this.props.specsAndFeaturesDisclaimer}
        />
      </div>
    );
  }
}

export default SpecsComparison;
